import { getCookie } from '../../helpers/CookieHandler';
import actionTypes from './action_types';
import welcomeTranslations from './data/welcomeTranslations.json';

const cookieLanguage = getCookie("welcomeLanguage").toLocaleLowerCase()
const initialLanguage = cookieLanguage ? cookieLanguage : "en"
const initialState = {
  content: welcomeTranslations.filter(({ lang }) => lang === initialLanguage)[0],  // Load default language content
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SWITCH_LANGUAGE:
      return {
        ...state,
        content: action.payload,  // Update state with the fetched content
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/mi-app/language/reducer.js